module.exports = __webpack_public_path__ + "static/img/ic_dianshi@2x.6bd128fd.png";